<template>
  <div class="apoc-page">
    <div class="apoc-container">
      <div class="apoc-header">
        <div class="header-row">
          <div class="header-brand">
            <img src="@/assets/header-logo.png" alt="DDD-DAYZ" />
          </div>

          <nav class="header-nav" aria-label="主要导航">
            <a href="https://www.kookapp.cn/app/invite/jryca0?spm=wxz.ai.0.0.6986nXYNnXYNyb" target="_blank" rel="noopener">KOOK</a>
            <a href="https://qm.qq.com/cgi-bin/qm/qr?spm=wxz.ai.0.0.6986nXYNnXYNyb&amp;_wv=1027&amp;k=fmIlHkd_QXkgNIW5fgrJgWLvKIDgjt61&amp;authKey=7N8Dhox%2BbR2KZBY%2FGJt70ystOJ9kFm0FkjwKT1sMGwjnK001U%2BAkMjr4uTv1gOem&amp;noverify=0&amp;group_code=27375122" target="_blank" rel="noopener">QQ</a>
            <a href="https://www.ddd-dayz.cn/" target="_blank" rel="noopener">官网</a>
          </nav>

          <button class="account-button" type="button" @click="goProfile">
            <span>个人信息</span>
          </button>
        </div>
      </div>

      <section class="home-hero" :style="{ backgroundImage: `url(${heroImage})` }">
      </section>
      <div class="support-entry-grid">
        <button type="button" class="support-entry" @click="openSponsorDialog('notice')">
          <span>赞助须知</span>
        </button>
        <button type="button" class="support-entry" @click="openSponsorDialog('guide')">
          <span>赞助教程</span>
        </button>
        <button type="button" class="support-entry" @click="openSponsorDialog('payment')">
          <span>赞助支付</span>
        </button>
      </div>
      <el-row :gutter="16">
        <el-col
          v-for="s in servers.filter(item => !String(item.name || '').includes('载具体验')).slice(0, 3)"
          :key="s.id"
          :xs="24"
          :sm="8"
          :md="8"
          :lg="8"
          :xl="8"
        >
          <el-card class="apoc-card" shadow="hover" @click.native="s.shopEnabled && enterShop(s)">
            <div class="banner-wrap">
              <img class="banner" :src="serverCover(s)" alt="">
              <div class="banner-overlay"></div>
              <div class="badge">{{ s.tag }}</div>
              <div class="banner-title">
                <div class="name">{{ s.name }}</div>
                <div class="desc">{{ s.desc }}</div>
              </div>
            </div>
            <div class="card-foot">
              <div class="card-address" @click.stop="copyText(detailAddress(s))" title="点击复制 IP:端口">
                <span>{{ detailAddress(s) || '未填写IP' }}</span>
                <small>复制地址</small>
              </div>
              <div class="player-stat">
                <div class="player-stat__row">
                  <span class="player-stat__label">在线玩家</span>
                  <span class="player-stat__value">{{ s.playersOnline }}/{{ s.playersMax }}</span>
                </div>
                <div class="player-stat__track" aria-hidden="true">
                  <span class="player-stat__fill" :style="{ width: playerPercent(s) + '%' }"></span>
                </div>
              </div>
              <div class="card-actions">
                <el-button
                  v-if="s.shopEnabled"
                  class="apoc-btn"
                  type="primary"
                  size="mini"
                  @click.stop="enterShop(s)">
                  进入商城
                </el-button>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <el-drawer :visible.sync="profileVisible" title="个人信息" size="360px">
      <el-descriptions :column="1" size="small" border>
        <el-descriptions-item label="昵称">{{ user && user.nickname }}</el-descriptions-item>
        <el-descriptions-item label="SteamID">{{ user && user.steamId }}</el-descriptions-item>
      </el-descriptions>
      <div class="drawer-tip">提示：个人资料与支付口令可在后端接口中重置或修改。</div>
    </el-drawer>

    <transition name="server-preview-fade">
      <div v-if="multiMap.visible" class="server-preview-layer" @click.self="closeMultiMapDialog">
        <div class="server-preview-card">
          <button
            type="button"
            class="server-preview__close"
            @click="closeMultiMapDialog"
            aria-label="关闭多地图倒计时"
            title="关闭多地图倒计时"
          >
            <i class="el-icon-close"></i>
          </button>
          <div v-if="multiMap.server" class="multi-map-panel">
            <div class="server-preview__desc">
              <div class="server-preview__title">{{ multiMap.server.name }}</div>
              <div class="server-preview__meta">
                <span>多地图战局倒计时</span>
              </div>
              <div class="multi-map-panel__list">
                <div v-for="m in extraMaps(multiMap.server)" :key="m.mapCode" class="multi-map-item">
                  <div class="multi-map-item__name">{{ m.mapName }}</div>
                  <div class="multi-map-item__timer">{{ formatCountdownLabel(m) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="server-preview-fade">
      <div v-if="detail.visible" class="server-preview-layer" @click.self="closeDetail">
        <div class="server-preview-card">
          <button
            type="button"
            class="server-preview__close"
            @click="closeDetail"
            aria-label="关闭详情"
            title="关闭详情"
          >
            <i class="el-icon-close"></i>
          </button>
          <div v-if="detail.server" class="server-preview">
            <div class="server-preview__desc">
              <div class="server-preview__title">{{ detail.server.name }}</div>
              <div class="server-preview__meta">
                <span v-if="detail.server._raw && detail.server._raw.map">地图：{{ detail.server._raw.map }}</span>
                <span>代码：{{ detail.server.id }}</span>
              </div>
              <p class="server-preview__text">{{ detail.server.desc || '暂无描述' }}</p>

              <div class="conn-panel">
                <div class="conn-chip" @click="copyText(detailAddress(detail.server))" title="点击复制 IP:端口">
                  <div class="conn-chip__main">
                    <span class="conn-chip__host">{{ detail.server._raw && detail.server._raw.ip ? detail.server._raw.ip : '未填写IP' }}</span>
                    <span v-if="detail.server._raw && detail.server._raw.port" class="conn-chip__port">:{{ detail.server._raw.port }}</span>
                  </div>
                  <div class="conn-chip__hint">
                    <span>复制地址</span>
                  </div>
                </div>
                <transition name="copy-flash">
                  <div v-if="copySignal" class="conn-copy-status">
                    <span class="pulse-dot"></span>
                    <span class="text">已复制 · Ready to connect</span>
                  </div>
                </transition>
              </div>

              <div v-if="detail.server" class="attachment-card">
                <div class="attachment-header">
                  <div class="attachment-title-wrap">
                    <span class="glow-dot"></span>
                    <div>
                      <div class="attachment-title">模组预设清单</div>
                      <div class="attachment-sub">{{ detail.server._raw && detail.server._raw.attachmentName || '模组预设文件' }}</div>
                    </div>
                  </div>
                  <button
                    type="button"
                    class="attachment-btn"
                    :class="{ 'is-disabled': !hasPreset(detail.server) }"
                    :disabled="!hasPreset(detail.server)"
                    @click="downloadAttachment(detail.server)"
                  >
                    <i class="el-icon-download"></i>
                    <span>{{ hasPreset(detail.server) ? '下载' : '未上传' }}</span>
                  </button>
                </div>
                <div class="attachment-body">
                  <div v-if="!hasPreset(detail.server)" class="attachment-empty">模组预设未上传</div>
                  <transition name="copy-flash">
                    <div v-if="downloadSignal" class="download-status">
                      <span class="pulse-dot"></span>
                      <span class="text">下载启动 · Safe travels!</span>
                    </div>
                  </transition>
                </div>
              </div>

              <div class="server-preview__actions">
                <button
                  v-if="detail.server && detail.server.shopEnabled"
                  type="button"
                  class="server-preview__action-btn"
                  @click="enterShop(detail.server)">
                  <i class="el-icon-shopping-cart-full"></i>
                  <span>进入商城</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="server-preview-fade">
      <div v-if="sponsorDialog" class="server-preview-layer" @click.self="closeSponsorDialog">
        <div class="sponsor-dialog" :class="{ 'sponsor-dialog--notice': sponsorDialog === 'notice' }">
          <button type="button" class="sponsor-dialog__close" @click="closeSponsorDialog" aria-label="关闭">
            <i class="el-icon-close"></i>
          </button>
          <template v-if="sponsorDialog === 'notice'">
            <div class="sponsor-dialog__eyebrow">SUPPORT NOTICE</div>
            <h3>服务器赞助须知</h3>
            <div class="sponsor-copy sponsor-notice">
              <p>感谢各位玩家对服务器的支持与认可。</p>
              <p>服务器的稳定运行离不开大家的帮助，所有赞助收入将用于服务器租赁、模组购买、程序开发、服务器维护以及后续内容更新。</p>
              <p>在进行赞助前，请您仔细阅读以下说明。完成赞助行为，即代表您已阅读并认可本须知全部内容。</p>

              <h4>一、赞助性质说明</h4>
              <p>服务器赞助并非商品购买行为，而是玩家对服务器运营与发展的支持。</p>
              <p>服务器将根据运营情况，为赞助玩家提供相应的游戏内福利内容。所有福利均属于服务器提供的额外支持，不构成任何形式的商品交易、承诺或永久服务保证。</p>
              <p>由于游戏版本更新、模组调整、服务器规则变化等不可控因素，部分赞助内容可能会进行优化、调整或变更，服务器管理组将尽可能保障玩家权益。</p>

              <h4>二、服务器运营说明</h4>
              <p>服务器鼓励玩家体验游戏原生硬核玩法，部分赞助内容可能会降低游戏难度或影响末世生存体验，请玩家根据自身需求理性选择。</p>
              <p>服务器运营需要投入大量成本与精力，包括：</p>
              <ul><li>服务器租赁费用</li><li>优质模组及插件购买</li><li>游戏内容开发</li><li>程序编写与调试</li><li>BUG修复与日常维护</li><li>服务器版本更新</li></ul>
              <p>服务器中的各种玩法内容均需要长期投入时间和精力制作，请玩家理解并珍惜管理团队的劳动成果。</p>
              <p class="notice-alert">未成年人禁止进行任何形式的赞助消费，请合理安排游戏时间，理性消费。</p>
              <p>感谢所有支持服务器发展的玩家，你们的支持是服务器持续运营的重要动力。</p>

              <h4>三、赞助资金用途</h4>
              <p>所有服务器赞助资金仅用于以下项目：</p>
              <ul><li>服务器租赁及硬件资源</li><li>游戏模组、插件及相关资源购买</li><li>服务器功能开发</li><li>日常维护与技术支持</li><li>后续版本更新及内容开发</li></ul>

              <h4>四、赞助继承规则</h4>
              <p>服务器赞助记录按照服务器独立计算。您在哪个服务器进行赞助，相关赞助权益默认归属于该服务器：</p>
              <ul><li>不同服务器之间不互通</li><li>不支持退款</li><li>不支持兑换其他服务器权益</li><li>不支持玩家之间转移</li></ul>
              <p>当您赞助的服务器永久关闭后，可选择其他服务器进行赞助金额继承。</p>

              <h4>五、美金赞助说明</h4>
              <p>服务器提供美金赞助服务。玩家购买美金后，可在游戏商城内使用美金购买高级载具、装备等游戏内容。</p>
              <p>美金赞助规则：</p>
              <ul><li>一次赞助，长期有效</li><li>后续每个服务器档位均可继承相同赞助金额</li><li>不受服务器重启、赛季更新影响</li></ul>
              <h5>美金赞助套餐</h5>
              <div class="notice-table-wrap"><table class="notice-table"><thead><tr><th>赞助金额</th><th>获得内容</th><th>赠送内容</th></tr></thead><tbody><tr><td>100元</td><td>20万卢布 / 2000美金</td><td>无</td></tr><tr><td>300元</td><td>60万卢布 / 6000美金</td><td>10万卢布 / 1000美金</td></tr><tr><td>500元</td><td>100万卢布 / 10000美金</td><td>20万卢布 / 2000美金</td></tr><tr><td>1000元</td><td>200万卢布 / 20000美金</td><td>100万卢布 / 10000美金</td></tr></tbody></table></div>

              <h4>六、其他赞助项目</h4>
              <h5>1. 贝壳赞助</h5><p>贝壳属于一次性游戏商城资源。</p><ul><li>贝壳赞助不支持跨服务器继承</li><li>商城内未使用的贝壳，可继承至新服务器档位</li><li>已消费贝壳不进行返还</li></ul>
              <h5>2. 技能赞助</h5><p>单项技能：100元。</p><ul><li>技能死亡后仍会损失对应经验值</li><li>技能赞助不可继承</li></ul><p class="notice-alert">2026年6月1日前完成的技能赞助，可在第13赛季领取一次；此日期之后完成的技能赞助，将不再提供继承服务。</p>
              <h5>3. 房屋赞助</h5><p>详细房屋信息请参考《房屋展示》。价格：200元 - 300元 / 单档使用权限。</p><p>包含：房屋使用权限、领地旗、大门、门锁、大型家具两个、饮水机、私人车库。</p><ul><li>房屋仅限当前服务器当前档位使用</li><li>不支持继承</li><li>不支持退款</li></ul>
              <h5>4. 死亡救援</h5><p>玩家死亡后，可购买空间密匙传送至死亡地点进行装备回收。价格：30元 / 次；单次服务，不支持继承。</p>
              <h5>5. 载具救援</h5><ul><li>卡死载具恢复：20元 / 次</li><li>落水载具救援：50元 / 次</li><li>单次服务，不支持继承</li></ul>
              <h5>6. 状态恢复</h5><p>玩家状态恢复：50元 / 次；单次服务，不支持继承。</p>

              <h4>七、商城赞助说明</h4>
              <p>商城地址：<a href="https://sc.ddd-dayz.cn/" target="_blank" rel="noopener">https://sc.ddd-dayz.cn/</a></p>
              <ul><li>贝壳：比例 1:1，不支持继承</li><li>钻石：比例 1:1，支持永久继承</li></ul>

              <h4>八、赞助权益及账号规则</h4>
              <p>所有赞助行为均视为玩家认可本《服务器赞助须知》。请玩家妥善保管自己的游戏账号及相关信息。</p>
              <p>以下情况视为主动放弃赞助权益：</p><ul><li>主动退出服务器QQ群</li><li>主动申请删除相关记录</li><li>因个人原因导致无法联系</li></ul>
              <p class="notice-alert">一旦玩家主动退出QQ群，所有赞助记录将被清空，不再提供找回、恢复或补偿服务。</p>

              <h4>九、最终说明</h4>
              <p>服务器管理组有权根据服务器运营情况、游戏版本变化、模组调整以及实际运行需求，对赞助内容、规则和福利进行优化调整。</p>
              <p>我们会尽最大努力维护服务器稳定运营，并持续为玩家提供更好的游戏体验。</p>
              <p>感谢每一位支持服务器发展的玩家。</p>
              <p class="notice-sign">服务器管理组</p>
            </div>
          </template>
          <template v-else-if="sponsorDialog === 'guide'">
            <div class="sponsor-dialog__eyebrow">SUPPORT GUIDE</div>
            <h3>服务器赞助教程</h3>
            <p class="sponsor-guide-intro">请按照以下步骤完成赞助及道具兑换：</p>
            <ol class="sponsor-steps">
              <li><b>第一步<br>充值网站账户</b><span>私聊服务器管理人员，告知您需要赞助的金额。<br>提供您的 <strong>17位 Steam ID</strong> 数字编号。<br>管理人员确认信息后，会将对应赞助金额充值至您的网站账户。</span></li>
              <li><b>第二步<br>购买游戏道具</b><span>登录服务器商城网站，选择您需要购买的道具。<br>点击购买，并输入您的支付密码。<br>密码验证成功后，系统会自动生成对应道具兑换码，点击兑换码即可进行复制。</span></li>
              <li><b>第三步<br>游戏内兑换</b><span>进入游戏服务器，找到一片周围没有障碍物的空旷草地，并确保角色站在安全位置。<br>打开游戏聊天窗口，将兑换码粘贴进去并按下回车发送。<br>兑换成功后，购买的赞助道具将会出现在您角色附近。</span></li>
            </ol>
            <p class="sponsor-guide-done">至此，赞助道具领取完成。</p>
            <div class="sponsor-guide-notes">
              <h4>注意事项</h4>
              <ul><li>每个兑换码均为一次性使用。</li><li>兑换成功后，兑换码将立即失效，无法重复使用。</li><li>请勿在危险区域、建筑物内或障碍物附近进行兑换，避免因地形问题导致道具无法正常出现。</li><li>如遇兑换异常，请保留兑换码及相关截图，并联系服务器管理人员处理。</li></ul>
            </div>
          </template>
          <template v-else>
            <div class="sponsor-dialog__eyebrow">SPONSOR PAYMENT</div>
            <h3>赞助支付</h3>
            <div class="payment-grid">
              <div class="payment-card payment-card--wechat">
                <div class="payment-qr-wrap">
                  <img class="payment-qr" src="@/assets/payment-wechat.png" alt="微信付款二维码">
                </div>
                <b>微信支付</b>
                <span>请使用微信扫码付款</span>
              </div>
              <div class="payment-card payment-card--alipay">
                <div class="payment-qr-wrap">
                  <img class="payment-qr" src="@/assets/payment-alipay.png" alt="支付宝付款二维码">
                </div>
                <b>支付宝</b>
                <span>请使用支付宝扫码付款</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// 顶部：新增
import api from '@/api'
import { BASE_URL } from '@/api/config'
import { session } from '@/store/session'
import { siteConfigState, ensureSiteConfig } from '@/store/site-config'

export default {
  name: 'ServerSelectPage',
  data () {
    return {
      heroImage: require('@/assets/home-hero.jpg'),
      profileVisible: false,
      loading: false, // ← 新增：加载状态
      servers: [], // ← 改成后端拉取的数据
      siteAnnouncement: '',
      hzValue: 437,
      hzTimer: null,
      detail: {
        visible: false,
        server: null
      },
      multiMap: {
        visible: false,
        server: null
      },
      copySignal: false,
      copySignalTimer: null,
      downloadSignal: false,
      downloadSignalTimer: null,
      countdownTimer: null,
      nowTs: Date.now(),
      sponsorDialog: ''
    }
  },
  computed: {
    user () { return session.user },
    brandTitle () { return siteConfigState.brandTitle },
    tickerMessages () {
      const text = (this.siteAnnouncement || '').trim()
      return text ? [text] : []
    },
    hzDisplay () {
      return this.hzValue.toFixed(2)
    }
  },
  created () {
    ensureSiteConfig()
    this.fetchServers()// ← 组件创建时拉取服务器列表
    this.fetchAnnouncement()
    this.startHzPulse()
    this.startCountdownTicker()
  },
  beforeDestroy () {
    if (this.copySignalTimer) {
      clearTimeout(this.copySignalTimer)
      this.copySignalTimer = null
    }
    if (this.downloadSignalTimer) {
      clearTimeout(this.downloadSignalTimer)
      this.downloadSignalTimer = null
    }
    if (this.hzTimer) {
      clearTimeout(this.hzTimer)
      this.hzTimer = null
    }
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
      this.countdownTimer = null
    }
  },
  methods: {
    openSponsorDialog (type) { this.sponsorDialog = type },
    closeSponsorDialog () { this.sponsorDialog = '' },
    serverCover (server) {
      const text = `${server && server.name ? server.name : ''} ${server && server.tag ? server.tag : ''} ${server && server.code ? server.code : ''}`
      if (text.includes('鹿岛') || /deerisle/i.test(text)) return require('@/assets/server-deerisle.png')
      if (text.includes('困难') || /hard/i.test(text)) return require('@/assets/server-chernarus-hard.png')
      return require('@/assets/server-chernarus-lite.png')
    },
    playerPercent (server) {
      const online = Number(server && server.playersOnline) || 0
      const max = Number(server && server.playersMax) || 0
      if (max <= 0) return 0
      return Math.max(0, Math.min(100, Math.round((online / max) * 100)))
    },
    async fetchServers () {
      this.loading = true
      try {
        const res = await api.getServers({ page: 1, size: 50, activeOnly: true })
        // res 形如：{ total, items: [...] }；items 的字段是后端的驼峰：serverCode/serverName/...
        this.servers = (res.items || []).map(s => ({
          id: s.serverCode, // 兼容你现有 enterShop('/shop/' + id)
          name: s.serverName,
          desc: s.serverDesc || '',
          tag: s.tag || '',
          bannerUrl: s.coverUrl || `https://picsum.photos/seed/${s.serverCode}/800/400`,
          shopEnabled: s.shopEnabled !== 0,
          playersOnline: s.onlinePlayers ?? 0,
          playersMax: s.maxPlayers ?? 0,
          _raw: s// 如需原始信息（ip/port等），备用
        }))
      } catch (e) {
        this.$message.error(e.message || '获取服务器列表失败')
      } finally {
        this.loading = false
      }
    },
    async fetchAnnouncement () {
      try {
        const res = await api.getSiteAnnouncement()
        this.siteAnnouncement = (res && res.announcement) || ''
      } catch (e) {
        this.siteAnnouncement = ''
        this.$message.error(e.message || '获取公告失败')
      }
    },
    resolveUrl (u) {
      if (!u) return ''
      if (/^https?:\/\//i.test(u)) return u
      // 形如 /upload/2025/10/27/xxx.jpg → http://你的后端域名:端口/upload/...
      return BASE_URL.replace(/\/+$/, '') + u
    },

    enterShop (s) {
      if (!s || s.shopEnabled === false) {
        this.$message.warning('该服务器未开启商城')
        return
      }
      this.$router.push({ name: 'Shop', params: { serverCode: s.id } }).catch(() => {})
    },

    openMultiMapDialog (s) {
      if (!s || !this.hasExtraMaps(s)) return
      this.multiMap.server = s
      this.multiMap.visible = true
    },
    closeMultiMapDialog () {
      this.multiMap.visible = false
      this.multiMap.server = null
    },

    openDetail (s) {
      this.detail.server = s
      this.detail.visible = true
      this.copySignal = false
      this.downloadSignal = false
    },
    closeDetail () {
      this.detail.visible = false
      this.detail.server = null
      this.copySignal = false
      if (this.copySignalTimer) {
        clearTimeout(this.copySignalTimer)
        this.copySignalTimer = null
      }
      if (this.downloadSignalTimer) {
        clearTimeout(this.downloadSignalTimer)
        this.downloadSignalTimer = null
      }
    },
    detailBanner (s) {
      if (!s) return ''
      const raw = s._raw || {}
      return this.resolveUrl(raw.coverUrl || s.bannerUrl)
    },
    detailAddress (s) {
      const raw = (s && s._raw) || {}
      const ip = raw.ip || ''
      const port = raw.port != null ? raw.port : ''
      if (!ip && !port) return '暂无地址'
      return port ? `${ip}:${port}` : ip
    },
    presetLink (s) {
      const raw = (s && s._raw) || {}
      return raw.attachmentUrl ? this.resolveUrl(raw.attachmentUrl) : ''
    },
    hasPreset (s) {
      return !!this.presetLink(s)
    },
    extraMaps (s) {
      const raw = (s && s._raw) || {}
      return Array.isArray(raw.extraMaps) ? raw.extraMaps : []
    },
    hasExtraMaps (s) {
      return this.extraMaps(s).length > 0
    },
    formatCountdownLabel (map) {
      if (!map) return ''
      if (map.countdownSeconds != null && map.countdownSeconds < 0) return '战局已结束'
      const remaining = this.remainingSeconds(map)
      if (remaining == null) return '战局倒计时：暂无'
      if (remaining <= 0) return '战局暂未开始'
      return `战局倒计时：${this.formatDuration(remaining)}`
    },
    remainingSeconds (map) {
      if (!map || map.countdownSeconds == null || map.countdownSeconds < 0 || !map.countdownStartedAt) return null
      const start = new Date(map.countdownStartedAt).getTime()
      if (!start || Number.isNaN(start)) return null
      const elapsed = Math.floor((this.nowTs - start) / 1000)
      const remaining = map.countdownSeconds - Math.max(elapsed, 0)
      return Math.max(remaining, 0)
    },
    formatDuration (seconds) {
      const total = Math.max(Number(seconds) || 0, 0)
      const hrs = Math.floor(total / 3600)
      const mins = Math.floor((total % 3600) / 60)
      const secs = total % 60
      const pad = v => String(v).padStart(2, '0')
      return `${pad(hrs)}小时${pad(mins)}分钟${pad(secs)}秒`
    },
    startCountdownTicker () {
      if (this.countdownTimer) return
      this.countdownTimer = setInterval(() => {
        this.nowTs = Date.now()
      }, 1000)
    },
    copyText (text) {
      const content = String(text || '').trim()
      if (!content || content === '暂无地址') {
        this.$message.warning('暂无可复制的地址')
        return
      }

      const done = () => {
        this.copySignal = true
        if (this.copySignalTimer) clearTimeout(this.copySignalTimer)
        this.copySignalTimer = setTimeout(() => {
          this.copySignal = false
          this.copySignalTimer = null
        }, 2000)
      }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(content).then(done).catch(() => {
            const t = document.createElement('textarea')
            t.value = content
            document.body.appendChild(t)
            t.select()
            document.execCommand('copy')
            document.body.removeChild(t)
            done()
          })
        } else {
          const t = document.createElement('textarea')
          t.value = content
          document.body.appendChild(t)
          t.select()
          document.execCommand('copy')
          document.body.removeChild(t)
          done()
        }
      } catch (e) {
        this.$message.error('复制失败，请手动选择文本复制')
      }
    },

    downloadAttachment (s) {
      const link = this.presetLink(s)
      if (!link) {
        this.$message.warning('模组预设未上传')
        return
      }
      const anchor = document.createElement('a')
      anchor.href = link
      anchor.download = (s && s._raw && s._raw.attachmentName) || 'mod-preset'
      anchor.target = '_blank'
      anchor.rel = 'noopener'
      document.body.appendChild(anchor)
      anchor.click()
      document.body.removeChild(anchor)
      this.downloadSignal = true
      if (this.downloadSignalTimer) clearTimeout(this.downloadSignalTimer)
      this.downloadSignalTimer = setTimeout(() => {
        this.downloadSignal = false
        this.downloadSignalTimer = null
      }, 2200)
    },

    goProfile () {
      this.$router.push('/profile').catch(() => {})
    },

    startHzPulse () {
      const tick = () => {
        const base = 437
        const swing = 12
        const jitter = Math.random() * swing - swing / 2
        this.hzValue = base + jitter
        this.hzTimer = setTimeout(tick, 900 + Math.random() * 400)
      }
      tick()
    }
  }
}
</script>

<style scoped>
/* ===== 布局与底色（与登录页一致） ===== */
.apoc-page {
  min-height: 100vh;
  background: #0b1320;
  color: #e2e8f0;
  position: relative;
  overflow-x: hidden;
}

/* 末日风微弱扫描线 + 暗角 */
.apoc-page::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(1200px 600px at 80% -10%, rgba(163,255,18,0.06), transparent 60%),
    radial-gradient(900px 500px at -10% 110%, rgba(0,255,255,0.06), transparent 60%),
    repeating-linear-gradient(
      to bottom,
      rgba(255,255,255,0.02),
      rgba(255,255,255,0.02) 2px,
      transparent 2px,
      transparent 4px
    );
  mix-blend-mode: screen;
}
.apoc-page::after {
  content: '';
  position: absolute;
  inset: 0;
  box-shadow: inset 0 0 120px rgba(0,0,0,0.7);
  pointer-events: none;
}

.apoc-container {
  position: relative;
  max-width: 1120px;
  margin: 0 auto;
  padding: 16px;
}

/* ===== 顶部品牌区 ===== */
.apoc-header {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 0 0 10px;
  height: 34px !important;
  min-height: 34px !important;
  max-height: 34px !important;
  width: 100%;
  box-sizing: border-box;
  border-radius: 16px;
  background: #2b2d30;
  margin-bottom: 12px;
  overflow: hidden;
}
.apoc-header::after {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: transparent;
  opacity: 1;
}
.header-row {
  position: relative;
  display: grid;
  grid-template-columns: minmax(210px, 1fr) auto minmax(210px, 1fr);
  align-items: center;
  column-gap: 28px;
  width: 100%;
  height: 34px;
  min-height: 34px;
  z-index: 2;
}
.header-brand {
  display: flex;
  align-items: center;
  align-self: center;
  transform: translateY(-20px);
}
.header-brand img {
  display: block;
  width: 98px;
  height: 26px;
  object-fit: contain;
  object-position: left center;
  filter: none;
}
.header-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 38px;
  align-self: center;
  transform: translateY(-20px);
}
.header-nav a {
  color: #d3d3d3;
  font: 800 13px/1 "Bahnschrift Condensed", Bahnschrift, "Microsoft YaHei", sans-serif;
  letter-spacing: .7px;
  text-decoration: none;
  transition: color .2s ease;
}
.header-nav a:hover,
.header-nav a.router-link-exact-active { color: #f6a623; }
.account-button {
  justify-self: end;
  align-self: stretch;
  height: 34px;
  min-width: 108px;
  padding: 0 16px;
  border: 0;
  border-radius: 0 16px 16px 0;
  background: #f5a834;
  color: #17130c;
  font: 800 11px/1 "Microsoft YaHei", sans-serif;
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: background .2s ease;
}
.account-button:hover { background: #f5a834; filter: brightness(1.06); }
.account-button i { margin-right: 7px; font-size: 14px; vertical-align: -1px; }

@media (max-width: 820px) {
  .apoc-header { width: 100%; min-width: 0; padding-left: 12px; }
  .header-row { grid-template-columns: 1fr auto; column-gap: 12px; }
  .header-brand img { width: 98px; height: 26px; }
  .header-nav { grid-column: 1 / -1; grid-row: 2; padding: 13px 0; border-top: 1px solid rgba(255,255,255,.06); }
  .account-button { grid-column: 2; grid-row: 1; min-width: 96px; height: 34px; min-height: 34px; }
}
@media (max-width: 520px) {
  .header-brand img { width: 92px; height: 24px; }
  .account-button { min-width: 108px; padding: 0 14px; }
  .header-nav { gap: 28px; }
}

/* 危险条纹分割线 */
.hazard-divider {
  height: 10px;
  margin: 8px 0 16px;
  background:
    repeating-linear-gradient(
      -45deg,
      #d1b200 0 12px,
      #0b1320 12px 24px
    );
  border-radius: 6px;
  opacity: 0.9;
}

/* ===== 顶部 Hz 条（置于 header 内，保持紧凑高度） ===== */
.hz-chip {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  border-radius: 10px;
  background: #0b1320;
  width: min(780px, 100%);
  height: 36px;
}
.hz-chip__tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  border-radius: 7px;
  background: rgba(34, 211, 238, 0.12);
  color: #d7fce5;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}
.hz-chip__meter {
  position: relative;
  width: 120px;
  height: 12px;
  border-radius: 6px;
  overflow: hidden;
  background: linear-gradient(90deg, rgba(34, 211, 238, 0.12), rgba(163, 255, 18, 0.14));
}
.hz-chip__pulse {
  position: absolute;
  inset: 0;
  background: repeating-linear-gradient(
    90deg,
    rgba(34,211,238,0.3),
    rgba(34,211,238,0.3) 10px,
    rgba(163,255,18,0.32) 18px,
    rgba(5, 12, 18, 0.08) 30px
  );
  mix-blend-mode: screen;
  animation: hz-beat 1.6s ease-in-out infinite;
}
.hz-chip__pulse--ghost {
  opacity: 0.3;
  filter: blur(3px);
  animation-duration: 2.2s;
  animation-delay: 0.16s;
}
.hz-chip__value {
  font-family: 'Rajdhani', 'Orbitron', 'DIN Alternate', 'Helvetica Neue', sans-serif;
  font-size: 14px;
  color: #e7ffe0;
  text-shadow: 0 0 6px rgba(163, 255, 18, 0.32);
  min-width: 86px;
}
.hz-chip__marquee {
  position: relative;
  overflow: hidden;
  flex: 1;
  min-width: 0;
  height: 24px;
  border-radius: 7px;
  background: #0b1320;
}
.hz-chip__marquee-track {
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  min-width: max-content;
  animation: hzMarquee 12s linear infinite;
}
.hz-chip__marquee-text {
  color: #dff9ff;
  font-size: 14px;
  font-family: 'Audiowide', 'Orbitron', 'Rajdhani', 'Helvetica Neue', sans-serif;
  letter-spacing: 0.12em;
  text-shadow: 0 0 6px rgba(34, 211, 238, 0.45);
  white-space: nowrap;
}

@keyframes hz-beat {
  0% { transform: translateX(-15%); opacity: 0.75; }
  40% { transform: translateX(10%); opacity: 1; }
  80% { transform: translateX(35%); opacity: 0.9; }
  100% { transform: translateX(60%); opacity: 0.8; }
}

@keyframes hzMarquee {
  0% { transform: translateX(100%); }
  96.67% { transform: translateX(-100%); }
  100% { transform: translateX(-100%); }
}

/* ===== 卡片：末日风（玻璃 + 霓虹边） ===== */
.apoc-card {
  margin-bottom: 16px;
  min-height: 390px;
  background: rgba(17, 27, 46, 0.8);
  border: 1px solid rgba(163, 255, 18, 0.18);
  backdrop-filter: blur(2px);
  transition: transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease;
}
.apoc-card:hover {
  transform: translateY(-2px);
  border-color: rgba(163, 255, 18, 0.45);
  box-shadow: 0 10px 28px rgba(0,0,0,0.45), 0 0 24px rgba(163,255,18,0.12);
}

/* Banner + 覆盖蒙层 + 标题排版 */
.banner-wrap {
  position: relative;
  cursor: pointer;
  border-radius: 14px;
  overflow: hidden;
}
.banner {
  width: 100%;
  height: 275px;
  object-fit: cover;
  display: block;
  filter: saturate(0.9) contrast(1.05);
}
.banner-overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(to bottom, rgba(0,0,0,0.0), rgba(0,0,0,0.55) 65%),
    radial-gradient(600px 220px at 20% 0%, rgba(0,255,170,0.12), transparent 60%);
  pointer-events: none;
}
.banner-title {
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 10px;
}
.name {
  font-weight: 800;
  text-shadow: 0 2px 8px rgba(0,0,0,0.6);
  color: #e5f0ff;
}
.desc {
  color: #94a3b8;
  font-size: 12px;
}

/* 角标（游戏模式/标签） */
.badge {
  position: absolute;
  top: 8px;
  left: 10px;
  padding: 8px 20px;
  font-size: 12px;
  letter-spacing: 1px;
  color: #111;
  background: #f4f4f4;
  border-radius: 999px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.35);
}

.player-stat {
  display: block;
  width: 100%;
  padding: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  flex-shrink: 0;
}
.player-stat__row { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-bottom: 7px; }
.player-stat__label {
  font-size: 12px;
  letter-spacing: 0.08em;
  color: #d7c9a5;
}
.player-stat__value {
  font-size: 16px;
  font-weight: 800;
  color: #f5a834;
  text-shadow: 0 0 10px rgba(246, 166, 35, .28);
}

/* 底部操作区 */
.card-foot {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  min-height: 70px;
  padding: 14px 0 4px;
  background: transparent !important;
  gap: 10px;
  flex-wrap: wrap;
}
.card-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: flex-end;
  align-self: flex-end;
}
.card-address {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid transparent;
  border-radius: 12px;
  background: #1e1e1e;
  color: #f3eee3;
  cursor: copy;
  transition: border-color .18s ease, box-shadow .18s ease;
}
.card-address:hover {
  border-color: #f5a834;
  box-shadow: 0 0 0 2px rgba(245,168,52,.16);
}
.card-address span { font-weight: 800; }
.card-address small { color: #aaa396; }

/* 霓虹绿主按钮（不影响全局，仅此页） */
.apoc-btn.el-button--primary {
  background: #16a34a;
  border-color: #16a34a;
}
.apoc-btn.el-button--primary:hover,
.apoc-btn.el-button--primary:focus {
  filter: brightness(1.1);
  border-color: #22c55e;
}

.apoc-btn--blue.el-button--primary {
  background: #2563eb;
  border-color: #2563eb;
  box-shadow: 0 0 12px rgba(37, 99, 235, 0.35);
}

.apoc-btn--blue.el-button--primary:hover,
.apoc-btn--blue.el-button--primary:focus {
  filter: brightness(1.08);
  border-color: #3b82f6;
  box-shadow: 0 0 16px rgba(59, 130, 246, 0.45);
}

.ghost-btn.el-button {
  color: #e2e8f0;
  border-color: rgba(163, 255, 18, 0.32);
  background: rgba(255, 255, 255, 0.02);
  transition: all .18s ease;
}

.ghost-btn.el-button:hover,
.ghost-btn.el-button:focus {
  color: #f8ffe6;
  border-color: rgba(163, 255, 18, 0.6);
  box-shadow: 0 0 0 3px rgba(163, 255, 18, 0.18);
}

/* 抽屉内提示 */
.drawer-tip {
  margin-top: 12px;
  color: #909399;
  font-size: 12px;
}

/* 服务器详情浮层（参考商品页风格） */
.server-preview-fade-enter-active,
.server-preview-fade-leave-active {
  transition: opacity .22s ease;
}

.server-preview-fade-enter,
.server-preview-fade-leave-to {
  opacity: 0;
}

.server-preview-layer {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 16px;
  background: radial-gradient(circle at center, rgba(9, 14, 25, 0.88), rgba(3, 5, 10, 0.95));
  backdrop-filter: blur(8px);
  z-index: 4000;
}

.server-preview-card {
  width: min(520px, 100%);
  background: #1e1e1e !important;
  border: 1px solid rgba(163, 255, 18, 0.35);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.65), 0 0 50px rgba(34, 211, 238, 0.18);
  position: relative;
  animation: server-preview-pop .24s ease;
}

@keyframes server-preview-pop {
  from { transform: translateY(16px) scale(.96); opacity: 0; }
  to { transform: translateY(0) scale(1); opacity: 1; }
}

.server-preview__close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(0, 0, 0, 0.35);
  color: #c9d7ee;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  transition: all .2s ease;
}

.server-preview__close:hover {
  border-color: rgba(163, 255, 18, 0.5);
  color: #f7ffe8;
  background: rgba(12, 20, 34, 0.6);
}

.server-preview {
  color: #e2e8f0;
  font-size: 14px;
}

.server-preview__media {
  width: 100%;
  padding-top: 52%;
  position: relative;
  background: rgba(9, 14, 25, 0.9);
}

.server-preview__media img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.server-preview__tag {
  position: absolute;
  left: 14px;
  bottom: 12px;
  padding: 6px 12px;
  border-radius: 12px;
  background: rgba(12, 20, 34, 0.8);
  border: 1px solid rgba(163, 255, 18, 0.38);
  color: #b4fac4;
  font-weight: 700;
  letter-spacing: 0.06em;
  backdrop-filter: blur(3px);
}

.server-preview__desc {
  padding: 20px 22px 22px;
  background: #1e1e1e !important;
  border-top: 0;
  box-shadow: none;
}

.server-preview__title {
  margin: 0 0 6px;
  font-size: 20px;
  color: #f7ffe8;
  text-shadow: 0 0 20px rgba(163, 255, 18, 0.25);
  font-weight: 800;
}

.server-preview__meta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  color: #99adc2;
  font-size: 12px;
  margin-bottom: 10px;
}

.multi-map-panel__list {
  display: grid;
  gap: 12px;
}

.multi-map-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(8, 18, 32, 0.8);
  border: 1px solid rgba(76, 164, 255, 0.25);
  box-shadow: inset 0 0 18px rgba(30, 120, 255, 0.2);
}

.multi-map-item__name {
  font-size: 14px;
  font-weight: 600;
  color: #d5ecff;
}

.multi-map-item__timer {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;
  font-size: 13px;
  letter-spacing: 0.08em;
  padding: 6px 10px;
  border-radius: 999px;
  background: radial-gradient(circle at center, rgba(78, 236, 255, 0.25), rgba(8, 16, 28, 0.9));
  border: 1px solid rgba(88, 220, 255, 0.45);
  color: #d7fbff;
  text-shadow: 0 0 10px rgba(88, 220, 255, 0.5);
  animation: timer-glow 1.8s ease-in-out infinite;
}

@keyframes timer-glow {
  0% {
    box-shadow: 0 0 8px rgba(88, 220, 255, 0.25);
  }
  50% {
    box-shadow: 0 0 18px rgba(88, 220, 255, 0.55);
  }
  100% {
    box-shadow: 0 0 8px rgba(88, 220, 255, 0.25);
  }
}

.server-preview__text {
  margin: 0 0 14px;
  white-space: pre-line;
  line-height: 1.6;
  color: #d6e3f5;
}

.conn-panel {
  margin-bottom: 14px;
  padding: 12px;
  border-radius: 12px;
  background: #1e1e1e !important;
  border: 0;
  box-shadow: none;
}

.conn-panel__label {
  font-size: 12px;
  letter-spacing: 0.06em;
  color: #9de5ff;
  opacity: 0.9;
}

.conn-chip {
  margin: 10px 0 6px;
  padding: 12px;
  border-radius: 12px;
  border: 0;
  background: #1e1e1e !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all .2s ease;
  gap: 12px;
}

.conn-chip:hover {
  border-color: rgba(163, 255, 18, 0.6);
  box-shadow: 0 0 0 3px rgba(163, 255, 18, 0.16), 0 12px 28px rgba(0, 0, 0, 0.35);
}

.conn-chip__main {
  display: flex;
  align-items: baseline;
  gap: 2px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;
  font-size: 18px;
  letter-spacing: 0.04em;
  color: #e6ffe6;
  text-shadow: 0 0 14px rgba(163, 255, 18, 0.35);
}

.conn-chip__port {
  color: #8ef8ff;
}

.conn-chip__hint {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #9fb3c8;
  font-size: 12px;
  letter-spacing: 0.05em;
}

.conn-panel__tips {
  font-size: 12px;
  color: #b9cee4;
  opacity: 0.9;
}

/* ===== 炫酷模组预设卡片 ===== */
.attachment-card {
  margin: 12px 0 16px;
  padding: 14px 14px 16px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(20, 34, 54, 0.92), rgba(9, 14, 25, 0.92));
  border: 1px solid rgba(163, 255, 18, 0.32);
  box-shadow: inset 0 0 40px rgba(5, 10, 18, 0.6), 0 14px 34px rgba(0, 0, 0, 0.32);
}

.attachment-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.attachment-title-wrap {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.glow-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #f5a834;
  box-shadow: 0 0 12px rgba(245, 168, 52, 0.6);
}

.attachment-title {
  font-weight: 800;
  color: #f1ffe8;
  letter-spacing: 0.04em;
}

.attachment-sub {
  color: #9bc1ff;
  font-size: 12px;
}

.attachment-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 12px;
  border: 1px solid rgba(34, 211, 238, 0.55);
  background: linear-gradient(120deg, rgba(37, 99, 235, 0.3), rgba(34, 197, 94, 0.3));
  color: #e7fffb;
  font-weight: 700;
  cursor: pointer;
  transition: all .2s ease;
}

.attachment-btn:hover {
  border-color: rgba(163, 255, 18, 0.7);
  box-shadow: 0 0 0 3px rgba(163, 255, 18, 0.14), 0 10px 24px rgba(0, 0, 0, 0.35);
  transform: translateY(-1px);
}

.attachment-btn.is-disabled,
.attachment-btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
  border-color: rgba(156, 163, 175, 0.6);
  background: linear-gradient(120deg, rgba(75, 85, 99, 0.35), rgba(107, 114, 128, 0.25));
  box-shadow: none;
}

.attachment-body {
  margin-top: 10px;
  padding: 12px;
  border-radius: 12px;
  border: 1px dashed rgba(163, 255, 18, 0.35);
  background: rgba(12, 20, 34, 0.7);
}

.attachment-hint {
  margin-top: 6px;
  font-size: 12px;
  color: #9fb3c8;
}

.attachment-empty {
  margin: 4px 0;
  font-size: 13px;
  color: #9da6b8;
  letter-spacing: 0.02em;
}

.download-status {
  margin-top: 10px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  background: radial-gradient(circle at 20% 40%, rgba(163, 255, 18, 0.18), transparent 50%),
    linear-gradient(90deg, rgba(37, 99, 235, 0.35), rgba(34, 197, 94, 0.35));
  color: #f4fff3;
  font-weight: 700;
  letter-spacing: 0.04em;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35), 0 0 18px rgba(163, 255, 18, 0.25);
}

.conn-copy-status {
  margin-top: 8px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  background: radial-gradient(circle at 20% 40%, rgba(34, 211, 238, 0.18), transparent 50%),
    linear-gradient(90deg, rgba(37, 99, 235, 0.35), rgba(22, 163, 74, 0.35));
  color: #e7fffb;
  font-weight: 700;
  letter-spacing: 0.04em;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35), 0 0 18px rgba(34, 211, 238, 0.25);
}

.conn-copy-status .text {
  text-shadow: 0 0 12px rgba(34, 211, 238, 0.4);
}

.pulse-dot {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #22d3ee;
  box-shadow: 0 0 0 0 rgba(34, 211, 238, 0.5);
  animation: pulse 1.6s infinite;
}

@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(34, 211, 238, 0.55); }
  70% { box-shadow: 0 0 0 12px rgba(34, 211, 238, 0); }
  100% { box-shadow: 0 0 0 0 rgba(34, 211, 238, 0); }
}

.copy-flash-enter-active,
.copy-flash-leave-active {
  transition: all .25s ease;
}

.copy-flash-enter,
.copy-flash-leave-to {
  transform: translateY(-6px);
  opacity: 0;
}

.server-preview__actions {
  margin-top: 16px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.server-preview__action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 12px;
  border: 1px solid rgba(163, 255, 18, 0.4);
  background: rgba(15, 25, 45, 0.85);
  color: #f7ffe8;
  font-weight: 700;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: all .2s ease;
}

.server-preview__action-btn:hover {
  border-color: rgba(163, 255, 18, 0.7);
  background: rgba(22, 163, 74, 0.35);
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35);
}

.server-preview__action-btn.ghost {
  border-color: rgba(34, 211, 238, 0.35);
  color: #d9f2ff;
  background: rgba(6, 14, 24, 0.9);
}

.server-preview__action-btn.ghost:hover {
  border-color: rgba(34, 211, 238, 0.6);
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35), 0 0 30px rgba(34, 211, 238, 0.2);
}

::v-deep(.server-copy-message) {
  z-index: 5001 !important;
}
.player-stat__track {
  display: block;
  height: 9px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(255, 255, 255, .1);
}
.player-stat__fill {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #f5a834;
  box-shadow: none;
}

.home-hero {
  position: relative;
  min-height: 600px;
  margin: 8px 0 14px;
  overflow: hidden;
  border-radius: 18px;
  border: 0;
  background-size: cover;
  background-position: center 44%;
  box-shadow: 0 24px 60px rgba(0, 0, 0, .5);
}
.home-hero__shade {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(0,0,0,.9) 0%, rgba(0,0,0,.48) 48%, rgba(0,0,0,.08) 78%),
              linear-gradient(0deg, rgba(0,0,0,.72), transparent 55%);
}
.home-hero__content {
  position: absolute;
  left: 44px;
  bottom: 46px;
  width: min(520px, calc(100% - 60px));
  text-align: left;
}
.home-hero__eyebrow, .server-section-head__kicker {
  display: block;
  color: #f6a623;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: .26em;
}
.home-hero h1 {
  margin: 10px 0 8px;
  color: #fff;
  font-size: clamp(34px, 5vw, 58px);
  line-height: 1.03;
  letter-spacing: .02em;
  text-shadow: 0 5px 26px rgba(0,0,0,.8);
}
.home-hero p { margin: 0; color: #d1cdc3; font-size: 15px; }
.server-section-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin: 0 0 14px;
  text-align: left;
}
.server-section-head h2 { margin: 5px 0 0; color: #f2eee5; font-size: 27px; }
.server-section-head__count { color: #918b7e; font-size: 12px; }

@media (max-width: 768px) {
  .home-hero { min-height: 290px; }
  .home-hero__content { left: 24px; bottom: 28px; }
  .home-hero h1 { font-size: 34px; }
}

.support-entry-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin: 12px 0 14px;
}
.support-entry {
  min-height: 54px;
  padding: 0 22px;
  border: 0;
  border-radius: 16px;
  background: #151411;
  color: #f3eee3;
  font: 800 16px/1 "Microsoft YaHei", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 12px 28px rgba(0,0,0,.25);
  transition: transform .2s ease, background .2s ease, color .2s ease;
}
.support-entry:hover { transform: translateY(-2px); background: #f6a623; color: #15110a; }
.support-entry__index { margin-right: 14px; color: #f6a623; font: 900 11px/1 Consolas, monospace; }
.support-entry:hover .support-entry__index { color: #15110a; }

.sponsor-dialog {
  position: relative;
  width: min(620px, calc(100vw - 32px));
  box-sizing: border-box;
  padding: 38px;
  border-radius: 22px;
  background: #090908;
  color: #eee9dc;
  text-align: left;
  box-shadow: 0 30px 90px rgba(0,0,0,.7);
}
.sponsor-dialog--notice { width: min(820px, calc(100vw - 32px)); }
.sponsor-dialog__close {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #f6a623;
  color: #15110a;
  cursor: pointer;
}
.sponsor-dialog__eyebrow { color: #f6a623; font: 900 10px/1 Consolas, monospace; letter-spacing: .24em; }
.sponsor-dialog h3 { margin: 10px 0 24px; font-size: 28px; font-weight: 800; }
.sponsor-copy { width: min(100%, 720px); margin: 0 auto; color: #c7c0b5; font-size: 15px; line-height: 1.9; }
.sponsor-copy p { padding: 7px 2px; margin: 0; border: 0; font-weight: 400; }
.sponsor-notice { max-height: 68vh; padding: 0 22px 18px 0; overflow-y: auto; scrollbar-color: #f6a623 #171611; }
.sponsor-notice h4 { margin: 28px 0 12px; padding: 11px 14px; border-left: 3px solid #f6a623; border-radius: 0 9px 9px 0; background: #1e1e1e; color: #f6a623; font-size: 18px; font-weight: 700; }
.sponsor-notice h5 { margin: 22px 0 5px; color: #eee9dc; font-size: 16px; }
.sponsor-notice ul { margin: 8px 0 16px; padding: 12px 18px 12px 36px; border-radius: 9px; background: #171717; color: #c9c2b7; }
.sponsor-notice li { padding: 4px 0; font-weight: 400; }
.sponsor-notice a { color: #f6a623; }
.sponsor-notice .notice-alert { margin: 10px 0; padding: 13px 16px; border: 0; border-left: 3px solid #f6a623; border-radius: 8px; background: #19150d; color: #f4d497; }
.notice-table-wrap { margin: 12px 0 20px; overflow-x: auto; }
.notice-table { width: 100%; min-width: 600px; border-collapse: collapse; color: #d8d1c5; }
.notice-table th, .notice-table td { padding: 11px 13px; border-bottom: 1px solid rgba(255,255,255,.08); text-align: left; }
.notice-table th { background: #f6a623; color: #17130c; }
.notice-table tr:nth-child(even) td { background: rgba(255,255,255,.025); }
.sponsor-notice .notice-sign { border: 0; color: #eee9dc; font-weight: 800; text-align: right; }
.sponsor-steps { margin: 0; padding: 0; list-style: none; counter-reset: step; }
.sponsor-steps li { display: grid; grid-template-columns: 110px 1fr; gap: 18px; margin-bottom: 10px; padding: 17px 18px; border: 0; border-left: 3px solid #f6a623; border-radius: 0 10px 10px 0; background: #1e1e1e; }
.sponsor-steps b { color: #f6a623; font-weight: 700; }
.sponsor-steps span { color: #c7c0b5; font-weight: 400; line-height: 1.85; }
.sponsor-guide-intro { margin: -12px 0 14px; color: #aaa396; }
.sponsor-steps strong { color: #f5a834; }
.sponsor-guide-done { margin: 20px 0; padding: 13px 16px; border-radius: 9px; background: #1e1e1e; color: #f5a834; font-weight: 800; text-align: center; }
.sponsor-guide-notes h4 { margin: 20px 0 8px; color: #f5a834; }
.sponsor-guide-notes ul { margin: 0; padding-left: 20px; color: #aaa396; line-height: 1.85; }
.payment-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; }
.payment-card { display: flex; flex-direction: column; align-items: center; padding: 18px; border-radius: 16px; background: #151411; text-align: center; }
.payment-qr-wrap { width: 100%; max-width: 330px; aspect-ratio: 1; margin-bottom: 14px; overflow: hidden; border-radius: 12px; background: #fff; }
.payment-qr { display: block; width: 100%; height: 100%; object-fit: contain; }
.payment-card b { color: #eee9dc; font-size: 17px; font-weight: 700; }
.payment-card > span { margin-top: 5px; color: #aaa396; font-size: 13px; font-weight: 400; }

@media (max-width: 700px) {
  .support-entry-grid { grid-template-columns: 1fr; }
  .payment-grid { grid-template-columns: 1fr; }
  .sponsor-dialog { padding: 32px 22px 24px; }
}

/* Current DDD visual palette and supplied background artwork. */
.apoc-page {
  background: url('../assets/site-background.jpg') center center / cover fixed no-repeat !important;
}
.apoc-page::before { display: none; }
.apoc-header { background: #1e1e1e !important; }
.account-button,
.sponsor-dialog__close,
.server-preview__close,
.apoc-btn.el-button--primary,
.server-preview__action-btn,
.attachment-btn {
  background: #f5a834 !important;
  background-image: none !important;
  color: #111 !important;
}
.support-entry {
  background: #1e1e1e !important;
  background-image: none !important;
  color: #f3eee3 !important;
}
.support-entry:hover {
  background: #f5a834 !important;
  color: #111 !important;
}
.player-stat__value { color: #f5a834 !important; text-shadow: none; }
.player-stat__fill { background: #f5a834 !important; box-shadow: none; }
.badge { background: #f4f4f4 !important; color: #111 !important; border-radius: 999px !important; }
.conn-chip:hover {
  border-color: #f5a834 !important;
  box-shadow: 0 0 0 3px rgba(245,168,52,.16), 0 12px 28px rgba(0,0,0,.35) !important;
}
</style>
